var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 -0.41 66.61 66.61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#42e5ba;}.cls-2,.cls-3{fill:none;stroke:#000000;}.cls-2{stroke-miterlimit:10;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "teamshape_iconsset_v1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.15,52.65V16.93A1.93,1.93,0,0,1,19.07,15H44.93a4.05,4.05,0,0,1,1.31.23A4.35,4.35,0,0,0,42.06,12H18.63a4.37,4.37,0,0,0-4.35,4.35V49.65a4.35,4.35,0,0,0,3,4.12A4.16,4.16,0,0,1,17.15,52.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.41,41.49v8a4.37,4.37,0,0,1-4.35,4.35H18.63a4.37,4.37,0,0,1-4.35-4.35V16.25a4.37,4.37,0,0,1,4.35-4.35H42.06a4.37,4.37,0,0,1,4.35,4.35V27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.63,36.7l8.08-8.08a3.39,3.39,0,0,0-4.79-4.79L37,36.7l3,3,1.75,1.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "41.84 41.49 33.22 45.26 37.04 36.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.2,
    y1: 19.96,
    x2: 37.1,
    y2: 19.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.2,
    y1: 24.77,
    x2: 34.13,
    y2: 24.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.2,
    y1: 29.57,
    x2: 30.35,
    y2: 29.57
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign-up.f16e4663581b7ca68c9654b2c207fe55.svg";
export { ForwardRef as ReactComponent };